import React, { useMemo } from "react";
import { TabsAlt, Box } from "orcs-design-system";
import { map, capitalize, pick } from "lodash";
import PATHS, { url } from "src/consts/urlPaths";
import { useWorkspaceFeatureFlags } from "src/contexts/global/WorkspaceContext";

export const WORKSPACE_SETTINGS_TABS = {
  DETAILS: "details",
  BRANDING: "branding",
  WORKSPACE_COMMUNICATIONS: "workspace-communications",
  FEATURE_TOGGLES: "feature-toggles",
};

export const WorkspaceSettingsTabs = () => {
  const { enableWorkspaceSettings } = useWorkspaceFeatureFlags();

  const visibleTabs = useMemo(() => {
    if (enableWorkspaceSettings) {
      return WORKSPACE_SETTINGS_TABS;
    }
    // Show all tabs except branding when disabled
    return pick(WORKSPACE_SETTINGS_TABS, [
      "DETAILS",
      "WORKSPACE_COMMUNICATIONS",
      "FEATURE_TOGGLES",
    ]);
  }, [enableWorkspaceSettings]);

  return (
    <Box mb="r" boxBorder="default" borderTop="none" borderBottom="none">
      <TabsAlt
        tabsList={map(visibleTabs, (tab) => {
          const tabName = capitalize(tab.replaceAll("-", " "));

          return {
            label: tabName,
            path: url(PATHS.WORKSPACE_SETTINGS, { tabType: tab }),
          };
        })}
      />
    </Box>
  );
};
